import initialState from "./store";
import actions from "./actions";
import reducer from "./reducer";
import { useCallback, useReducer } from "react";
import { ContextProviderProps } from "../../types/contexts/context.types";
import EligibleDependentContext from "./eligibleDependentContext";
import { Member } from "../../types/components/member.types";

const EligibleDependentContextProvider = ({ children }: ContextProviderProps): JSX.Element => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {
		eligiblity: state,
		setEligiblity: useCallback(
			(eligiblity: {
				eligibleDependents: Member[];
				ineligibleRelationshipDependents: Member[];
				ineligibleDependents: Member[];
			}) => dispatch({ type: actions.SET_ELIGIBLE_DEPENDENT, payload: eligiblity }),
			[]
		)
	};

	return <EligibleDependentContext.Provider value={value}>{children}</EligibleDependentContext.Provider>;
};

export default EligibleDependentContextProvider;
